module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "Basic-Text-Frame"
  }, [_c('p', {
    staticClass: "Paragraph-Style-2"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-1",
    attrs: {
      "alt": "",
      "src": "image/1.png"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "Book_Book_Subtitle"
  }, [_vm._v("How to Make It a Better World")]), _vm._v(" "), _c('p', {
    staticClass: "Basic-Paragraph ParaOverride-1"
  }, [_c('span', {
    staticClass: "CharOverride-1"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Book_Book_Editors"
  }, [_vm._v("The Editors of Conari Press")]), _vm._v(" "), _c('p', {
    staticClass: "Book_Book_Text"
  }, [_vm._v("Foreword by Brenda Knight and Dawna Markova, PhD")]), _vm._v(" "), _c('p', {
    staticClass: "ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "Book_Book_Text"
  }, [_vm._v("Preface ")]), _vm._v(" "), _c('p', {
    staticClass: "Book_Book_Text"
  }, [_vm._v("by Daphne Rose Kingma")]), _vm._v(" "), _c('p', {
    staticClass: "ParaOverride-2"
  }, [_c('span', {
    staticClass: "CharOverride-2"
  })]), _vm._v(" "), _c('p', {
    staticClass: "pictures_Conari-Logo ParaOverride-3"
  }, [_c('img', {
    staticClass: "_idGenObjectAttribute-2",
    attrs: {
      "alt": "",
      "src": "image/cplogo_titlepage.png"
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6ae54405","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/RandomActsKindness-1.vue
// module id = 63
// module chunks = 0